  <div class="category-heading">
    <ion-icon ios="ios-add-circle-outline" md="md-add-circle"></ion-icon>
    <h2 translate>WEEK.RESOURCES</h2>
  </div>

  <ng-template [ngIf]="loadingData">

    <div class="v-box full-width align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>

  </ng-template>
  <ng-template [ngIf]="!loadingData">

    <ng-template ngFor let-item [ngForOf]="resources">
      <div class="info" translate>{{item}}</div>
    </ng-template>

  </ng-template>

  <div class="category-heading">
    <ion-icon ios="ios-remove-circle-outline" md="md-remove-circle"></ion-icon>
    <h2 translate>WEEK.IMPEDIMENTS</h2>
  </div>

  <ng-template [ngIf]="loadingData">

    <div class="v-box full-width align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>

  </ng-template>
  <ng-template [ngIf]="!loadingData">

    <ng-template ngFor let-item [ngForOf]="obstacles">
      <div class="info" translate>{{item}}</div>
    </ng-template>

  </ng-template>

